@if (slotName$ | async; as slotName) {
<epc-content-slot [slotName]="slotName"></epc-content-slot>
}
